import { OpenPopup } from "../../../actions/ui";
import Config from "../../../config/main";
import gamesUrlFromHelpers from "../../../helpers/creationGamesUrl";
import { store } from "../../../index/terminalApp";
import cookie from 'react-cookie';
import { t } from "../../../helpers/translator";
import { toast } from "react-toastify";

export const openCasinoGame = (game, playType = 'real') => {
    const isLiveGame = game.cats?.some(category => category.title.includes("Live"));
    const { user: userInfo } = store.getState();

    let gameUrl;

    if (!game.TableId && !game.types.realMode && !game.types.viewMode && !game.types.funMode) return;

    if (isLiveGame || !Config.casino.enableBaseAuthorization) {
        const authData = JSON.parse(sessionStorage.getItem("authData"));
        const casinoToken = encodeURIComponent(userInfo.loggedIn ? userInfo.authData.auth_token : authData.token);
        const queryParams = `token=${casinoToken}&platformType=2&iscashdesk=${!userInfo.loggedIn}`;

        if (game.TableId) {
            gameUrl = game.Limits[0].OpenUrl.startsWith('?')
                ? `${Config.liveCasino.tableUrlForBetOnPoker}/${game.Limits[0].OpenUrl}&${queryParams}`
                : `${Config.liveCasino.tableURL + game.Limits[0].OpenUrl}/?${queryParams}`;
        } else {
            gameUrl = `${Config.urlPrefix}gameid=${game.extearnal_game_id}&openType=${playType}&provider=${game.provider}&=activeGroupId=${Config.liveCasinoActiveGroup[game.name]}&language=en&partnerid=${authData.pid}&devicetypeid=6&${queryParams}`;
        }
    } else gameUrl = getCasinoGameAuthorizationUrl(game.extearnal_game_id, playType);

    store.dispatch(OpenPopup('iframe', { iframeUrl: gameUrl }));
};

const getCasinoGameAuthorizationUrl = (externalGameId, playType, authToken = cookie.load("authData")) => {
    let gameUrl = gamesUrlFromHelpers.processingGamesUrl().casinoAuthorizationUrl + Config.casino.gamesAuthorizationUrl + '?partnerId=' + Config.main.site_id + '&gameId=' +
        externalGameId + '&language=' + Config.main.availableLanguages[Config.env.lang].short.toLowerCase() + '&openType=' + playType + '&isMobile=true';

    playType === 'real' && authToken && (gameUrl += ('&token=' + authToken.auth_token));
    return gameUrl;
}

export const restrictForLoggedIn = cb => {
    let activeToastId;

    return (...args) => {
        const { user } = store.getState();

        if (!user?.loggedIn && !user?.loggedInByRFID) {
            
            if (!toast.isActive(activeToastId))
                activeToastId = toast.info(t("Please login to join a tournament"));
                
            return;
        }
    
        cb(args);
    }
};